import React, { useMemo } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import DataGrid from '../../../../common/DataGrid/DataGrid';
import { IconButton } from '../../../../common/controls/Controls';
import { isUndefined } from 'lodash';
import { SeriousDeleteQuestion } from '../../../../common/DeleteQuestion/SeriousDeleteQuestion.jsx';

export function SensorsTable({
  sensors,
  onAttributesClick,
  onPreviewClick,
  onEditClick,
  onDelete,
}) {
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      {
        title: t('Názov senzora'),
        dataIndex: 'name',
        ellipsis: true,
      },
      {
        title: t('Popis'),
        dataIndex: 'description',
        render: (description) => (
          <span style={{ whiteSpace: 'pre-line' }}>{description}</span>
        ),
      },
      {
        title: t('IEEE Adresa'),
        dataIndex: 'ieee_address',
        ellipsis: true,
        width: 200,
      },
      {
        title: t('Počet atribútov'),
        dataIndex: 'sensor_attributes',
        render: (attributes) => attributes?.length || 0,
        width: 150,
      },
    ],
    [t],
  );

  return (
    <DataGrid
      rowKey={(sensor) => sensor.id}
      columns={columns}
      dataSource={sensors}
      permissionsBasic={'meteo-station'}
      uniqueTableId={'meteo-station-sensors-table'}
      onPreviewClick={onPreviewClick}
      rowClickOpensPreview
      onRowClick={onEditClick}
      onEditClick={onEditClick}
      onDelete={onDelete}
      optionsWidth={250}
      customSettings={(row) => (
        <>
          {!isUndefined(onAttributesClick) ? (
            <IconButton
              icon={<i className="fa-solid fa-circle-nodes"></i>}
              tooltip={t('Správa atribútov')}
              onClick={(e) => {
                // Solution to antd Table.onRow callback also catching these click events.
                e.stopPropagation();

                onAttributesClick(row);
              }}
            />
          ) : null}
        </>
      )}
      question={
        <SeriousDeleteQuestion
          firstText={t('Naozaj chcete vymazať tento senzor?')}
          mainNotice={t(
            'So senzorom sa vymažú aj VŠETKY jeho atribúty a VŠETKY ich hodnoty!',
          )}
          lastText={t(
            'Prosím uistite sa, že mažete správny senzor, aby ste predišli nežiadúcim komplikáciam!',
          )}
        />
      }
    />
  );
}

SensorsTable.propTypes = {
  sensors: PropTypes.array.isRequired,
  onAttributesClick: PropTypes.func,
  onPreviewClick: PropTypes.func,
  onEditClick: PropTypes.func,
  onDelete: PropTypes.func,
};
